import {
  Directive,
  EventEmitter,
  inject,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { ContentInitializedEvent } from '../team-apis/content/content-initialized-event';
import { shellConnectorToken } from '../team-apis/core/shell-connector';
import {
  PointType,
  ShapeType,
} from '../team-apis/otterdam/answers/shape-typings';
import { AnnotationOutput } from '../team-apis/otterdam/outputs/annotation-output';
import { Project } from '../team-apis/otterdam/project';
import { User } from '../team-apis/otterdam/user';
import { AbstractContentConnector } from './abstract-content-connector';
import { AbstractSensorContentStore } from './state/abstract-sensor-content-store';
import { settingsStoreToken } from './state/setting-state';

@Directive()
export abstract class AbstractContentInitializer<
    T extends AbstractContentConnector<PointType, ShapeType>,
  >
  extends DirectiveSuperclass
  implements OnInit
{
  @Input({ required: true }) project!: Project;
  @Input({ required: true }) output!: AnnotationOutput;
  @Input({ required: true }) readOnly!: boolean;
  @Input({ required: true }) isClientFeedbacksEditable!: boolean;
  @Input({ required: true }) isShapeFeedbackEditable!: boolean;
  @Input({ required: true }) currentUser!: User;
  @Input() frameNumber = 0;
  @Input() stepId?: number;

  @Output()
  private initializationComplete = new EventEmitter<ContentInitializedEvent>();

  protected store = inject(AbstractSensorContentStore);
  protected settingsStore = inject(settingsStoreToken);
  protected shellConnector = inject(shellConnectorToken);

  private contentConnector!: T;

  constructor(public injector: Injector) {
    super();
  }

  ngOnInit() {
    // initialize the store first because so many things depend on it
    this.store.assign({
      project: this.project,
      output: this.output,
      readOnly: this.readOnly,
      isShapeFeedbackEditable: this.isShapeFeedbackEditable,
      isClientFeedbacksEditable: this.isClientFeedbacksEditable,
      currentUser: this.currentUser,
      stepId: this.stepId,
    });

    this.contentConnector = this.getContentConnector();

    this.setUpSubscriptions(this.store);

    this.initializationComplete.emit({
      connector: this.contentConnector,
      injector: this.injector,
    });
  }

  protected setUpSubscriptions(_store: AbstractSensorContentStore) {}

  protected abstract getContentConnector(): T;
}
